import { CREATE_CATEGORY, GET_CATEGORY, SET_ALL_CATEGORIES, SET_ALL_CATEGORIES_SELECT, UPDATE_CATEGORY } from "../../reducerTypes"

const initialState = {
  getData: {},
  getList: [],
  selectData: []
}

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_CATEGORIES:
      return {
        ...state,
        getList: action.payload
      }
    case CREATE_CATEGORY:
      return {
        ...state,
        getData: action.payload
      }
    case GET_CATEGORY:
      return {
        ...state,
        getData: action.payload
      }
    case UPDATE_CATEGORY:
      return {
        ...state,
        getData: action.payload
      }
    case SET_ALL_CATEGORIES_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data)=>{
        selectData.push({
          value: data.id,
          label: `${data.name}`
        })
        return data
      });
      return{
        ...state,
        selectData: selectData
      }
    default:
      return state
  }
}

export default categoryReducer
